/* eslint-disable max-len */
import {
    Typography,
    Space,
    Divider,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { BedIcon, TickIcon } from '@/assets/images/icons/screens';

const Rooms = ({ reservationData, currency }) => {
    const { t } = useTranslation();
    const rooms = reservationData?.data;
    if (!rooms) return null;
    return (
        <div className="rooms">
            <Space>
                <BedIcon />
                <Typography.Title level={5}>
                    {t('Rooms')}
                </Typography.Title>
            </Space>
            {rooms.map((room) => {
                const totalRoomPrice = room.prices.reduce((sum, price) => {
                    const base = price.price * price.no_rooms;

                    const extraBedCharge = price.extra_bed_charges_type === 'Decimal'
                        ? parseFloat(price.extra_beds_price) * price.extra_beds
                        : ((price.price * parseFloat(price.extra_beds_price)) / 100) * price.extra_beds;

                    const extraServiceCharge = (price.extra_services || []).reduce((serviceSum, service) => {
                        return serviceSum + service.price * price.no_rooms;
                    }, 0);

                    return sum + base + extraBedCharge + extraServiceCharge;
                }, 0);

                return (
                    <div key={room.room_id} className="room-item-wrapper">
                        <Space align="start" className="room-item">
                            <div className="list">
                                <Typography.Paragraph>
                                    {`${room.room_name} ( x ${room.prices.reduce((acc, price) => acc + price.no_rooms, 0)} ) ${t('Rooms')}`}
                                </Typography.Paragraph>
                                <Typography.Paragraph>
                                    {`${room.prices.reduce((acc, price) => acc + price.extra_beds, 0)} ${t('Extra Bed')} ( + ${room.prices?.[0]?.extra_beds_price} ${room.prices?.[0]?.extra_bed_charges_type === 'Decimal' ? currency : '%'} ${t('over room price')})`}
                                </Typography.Paragraph>
                                {Object.entries(
                                    room.prices.reduce((acc, p) => {
                                        (p.extra_services || []).forEach((service) => {
                                            const key = service.id || service.name;
                                            if (!acc[key]) {
                                                acc[key] = { ...service, totalRooms: 0 };
                                            }
                                            acc[key].totalRooms += p.no_rooms;
                                        });
                                        return acc;
                                    }, {}),
                                ).map(([key, service]) => (
                                    <div key={key}>
                                        <Space align="start">
                                            <TickIcon />
                                            <span>{`${service.name} × ${service.totalRooms}`}</span>
                                        </Space>
                                    </div>
                                ))}
                            </div>
                            <div>
                                <Typography.Text className="total-price">
                                    {`${currency}${totalRoomPrice.toFixed(2)}`}
                                </Typography.Text>
                            </div>
                        </Space>
                        <Divider />
                    </div>
                );
            })}
        </div>
    );
};

export default Rooms;
